var _mask, _g, _defs, _animateMotion, _animate;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaneDesktop = function SvgPlaneDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-23161a6c": "",
    viewBox: "0 0 1440 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "plane-desktop"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    "data-v-23161a6c": "",
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 727
  }, /*#__PURE__*/React.createElement("rect", {
    "data-v-23161a6c": "",
    width: 1440,
    height: 727,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-23161a6c": "",
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 720,
    cy: 612,
    r: 510.5,
    stroke: "#EDF2FF",
    strokeWidth: 175
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    id: "theSun",
    cx: 526.5,
    cy: 197.5,
    r: 60.5,
    fill: "#F5DEAD"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 720,
    cy: 612,
    r: 419.5,
    fill: "white",
    stroke: "#266BEE",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    id: "motionPath",
    d: "M1024.8344556199154,269.356689453125 C982.5404687403934,218.9761505126953 930.2173817763687,179.22703552246094 871.6625094619521,152.9907989501953 C813.1076988985151,126.7543716430664 749.7882445069117,114.69071197509766 686.2974928981421,117.67414093017578 C622.8074823011266,120.65656280517578 560.7388557505183,138.61322021484375 504.5941859174345,170.23870849609375 C458.20187915417046,196.37100219726562 416.81519941661827,231.294677734375 382.43385954980477,273.189697265625 "
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    d: "M1059.62 310.207C1014.68 259.8 959.081 220.03 896.86 193.78C834.639 167.53 767.355 155.46 699.889 158.445C632.424 161.429 566.469 179.395 506.809 211.037C457.512 237.183 413.534 272.125 377 314.042",
    stroke: "#266BEE",
    strokeLinecap: "round",
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 720,
    cy: 612,
    r: 426.5,
    stroke: "#588FF1"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 720,
    cy: 612,
    r: 437.5,
    stroke: "#8EB4F5"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    opacity: 0.5,
    cx: 720,
    cy: 612,
    r: 509.5,
    stroke: "#C6D9FA"
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-23161a6c": "",
    id: "plane",
    transform: "scale(1, 1) translate(-881.41, -173.263) rotate(-25.1532, 884.941, 160.57)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    d: "M905.115 177.383C866.303 161.326 825.58 150.457 784 145.03",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    d: "M756.781 138.492C806.753 142.446 855.795 154.22 902.115 173.383",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.41 173.263C882.287 173.68 883.164 174.097 884.035 174.528L903.866 183.15C904.176 183.283 904.493 183.381 904.817 183.442C904.959 183.468 905.104 183.495 905.251 183.523C906.004 183.665 906.817 183.818 907.632 183.915C909.165 184.097 910.699 184.131 912.188 183.529C913.329 183.069 913.749 181.695 913.079 180.5C912.742 179.901 912.38 179.304 911.952 178.8C909.886 176.367 907.451 174.604 904.759 173.404C904.201 173.156 903.643 172.907 903.085 172.658C899.866 171.223 896.647 169.788 893.426 168.36C893.402 168.185 893.329 168.011 893.197 167.854L888.275 161.996C888.176 161.879 888.052 161.786 887.912 161.724L885.697 160.748C884.969 160.427 884.176 161.044 884.307 161.829L884.763 164.541C882.486 163.545 880.208 162.554 877.927 161.573C875.637 160.587 873.565 159.385 871.987 157.109C871.887 156.963 871.768 156.837 871.649 156.711C871.532 156.588 871.416 156.465 871.318 156.324L871.304 156.304C871.073 155.973 870.834 155.631 870.685 155.246C870.111 153.773 869.541 152.296 868.971 150.819C867.995 148.287 867.018 145.754 866.018 143.234C865.771 142.609 865.351 141.977 864.873 141.619C864.417 141.276 863.896 141.06 863.374 140.844C863.151 140.752 862.928 140.659 862.71 140.557C862.352 140.392 862.195 140.608 862.151 141C862.134 141.139 862.135 141.283 862.136 141.426C862.136 141.471 862.136 141.516 862.136 141.561C862.138 142.631 862.14 143.702 862.143 144.772C862.149 147.722 862.155 150.67 862.16 153.618C862.161 153.832 862.155 154.047 862.147 154.301C862.143 154.419 862.139 154.546 862.136 154.684L858.296 152.987C858.267 153.039 858.253 153.064 858.241 153.087C858.226 153.115 858.213 153.138 858.178 153.201C858.373 153.458 858.568 153.715 858.764 153.973C859.437 154.858 860.109 155.743 860.768 156.64C860.894 156.811 860.957 157.065 861.01 157.292C861.05 157.464 861.074 157.649 861.098 157.833C861.143 158.18 861.188 158.525 861.34 158.78C861.754 159.479 862.264 160.118 862.811 160.675C866.706 164.648 871.084 167.72 875.661 170.347C877.537 171.423 879.473 172.343 881.41 173.263Z",
    fill: "#266BEE"
  })), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    d: "M378.5 312L350.5 285.5",
    stroke: "#8EB4F5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-23161a6c": "",
    d: "M1057.5 309L1085.5 282.5",
    stroke: "#8EB4F5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 378.5,
    cy: 311.5,
    r: 8,
    fill: "#82D453",
    stroke: "#EDF2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-v-23161a6c": "",
    x: 352.647,
    y: 284.11,
    width: 29.9982,
    height: 20.6655,
    transform: "rotate(-46 352.647 284.11)",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-v-23161a6c": "",
    x: 352.647,
    y: 284.11,
    width: 29.9982,
    height: 20.6655,
    transform: "rotate(-46 352.647 284.11)",
    fill: "url(#pattern1)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-v-23161a6c": "",
    x: 352.647,
    y: 284.11,
    width: 29.9982,
    height: 20.6655,
    transform: "rotate(-46 352.647 284.11)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    "data-v-23161a6c": "",
    cx: 1057.5,
    cy: 308.5,
    r: 7.5,
    fill: "#82D453"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-v-23161a6c": "",
    x: 1086.52,
    y: 284.586,
    width: 29.8805,
    height: 20.67,
    transform: "rotate(46.2507 1086.52 284.586)",
    fill: "url(#pattern2)",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "data-v-23161a6c": ""
  }, /*#__PURE__*/React.createElement("pattern", {
    "data-v-23161a6c": "",
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    "data-v-23161a6c": "",
    xlinkHref: "#image0",
    transform: "scale(0.000833333 0.00125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    "data-v-23161a6c": "",
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    "data-v-23161a6c": "",
    xlinkHref: "#image0",
    transform: "scale(0.000833333 0.00125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    "data-v-23161a6c": "",
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    "data-v-23161a6c": "",
    xlinkHref: "#image1",
    transform: "translate(-0.00223211) scale(0.000837054 0.00125)"
  })), /*#__PURE__*/React.createElement("image", {
    "data-v-23161a6c": "",
    id: "image0",
    width: 1200,
    height: 800,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAMgCAMAAAAEPmswAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAllBMVEUAd0kukGrO5dz////75+Xob2fgPDEFek13tp75/Pv//v7zsa3iRjs0k27T6OCFmTIHeUj/uBzUrSM1hED7tx2ImjH75uTobmaUaxD+txwAAAA7KwbanRgJBgGIYg/9txzshn/qfXbTrSQ0hUA8KwcKBwH6/PsvkGve4fBhbbZVYrD+/v+ZodANII8AFInf4vBDUqhBUKdQR1nMAAAAAWJLR0QDEQxM8gAAAAd0SU1FB+QGHhAWJTU95NgAABGuSURBVHja7dgHUhRhFEbRNkdQDKhjBgNm3f/mXIEUUCBz+52zhfn7qztvWbbMlavXLtT1GzeBqGXr3Lp950IX6+69+352MFgiCxg3WCIL6AyWyAJCgyWygM5giSwgNFgiC+gMlsgCQoMlsoDOYIksIDRYIgvoDJbIAkKDJbKAzmCJLCA0WCIL6AyWyAJCgyWygCVEZIHBElkiCwyWyAImD5bIAoMlskQWGCyRBYweLJEFBktkiSwwWCILmD1YIgsMlsgSWWCwRBYwerBEFhgskSWywGCJLGD2YIksMFgiS2SBwRJZwOjBEllgsESWyAKDJbKA2YMlssBgiSyRBQZLZAGjB0tkgcESWSILDJbIAmYPlsgCgyWyRBYYLJEFjB4skQUGS2SJLDBYIguYPVgiCwyWyBJZYLBEFjB6sEQWGCyRJbLAYIksYPZgiSwwWCJLZIHBElnA6MESWWCwRJbIAoMlsoDZgyWywGCJLJEFBktkAaMHa1l2dkUWGCyRJbLAYLlkAXMHS2SBwRJZIgsMlsgCRg+WyAKDJbJEFhgskQUGaxFZIgsMlsgSWWCwRBYYLJElssBgiSyRBQZLZIHBElkiCwyWyAIMlsgCgyWyRBYYLJEFGCyRBQZLZIksMFgiCzBYIgsMlsgSWWCwRBZgsEQWGCyRJbLAYIkswGCJLMgP1oOHZuk4O7siC7ZmsPYePbZKIgsig7X35KnIcsmCyGDtiSyRBZ3BElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsqAzWCJLZEFosESWyILOYIkskQWhwRJZIgs6gyWyRBaEBktkXXZk7T/zMuGkgyWyRBaEBktkuWRBZ7BElsiC0GCJLJEFncESWSILQoMlskQWdAZLZIksCA2WyBJZ0BkskSWyIDRYIktkQWewRJbIgtBgiSyRBZ3BElkiC0KDJbJEFnQGS2SJLAgNlsgSWdAZLJElsiA0WCJLZEFnsESWyILQYIkskQWdwRJZIgtCgyWyRBZ0BktkiSwIDZbIElnQGSyRJbIgNFgiS2RBZ7BElsiC0GCJLJEFncESWSILQoMlskQWdAZLZIksCA2WyBJZ0BkskSWyIDRYIktkQWewRJbIgtBgiSyRBZ3BElkiC0KDJbJEFnQGS2SJLAgNlsgSWdAZLJElsiA0WCJLZEFnsESWyILQYIkskQWdwRJZIgtCgyWyRBZ0BktkiSwIDZbIElnQGSyRJbLgXAfr+Ys9kbXiyNp/5pGzosHavHwlskQWRAZr8/rNW5HlkgWNwdqILJEFncESWSILOoMlskQWhAZLZIks6AyWyBJZEBoskSWyoDNYIktkQWiwRJbIgs5giSyRBaHBElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsqAzWCJLZEFosESWyILOYIkskQWhwRJZIgs6gyWyRBaEBktkiSzoDJbIElkQGiyRJbKgM1giS2RBaLBElsiCzmCJLJEFocESWSILOoMlskQWhAZLZIks6AyWyBJZEBoskSWyoDNYIktkQWiwRJbIgs5giSyRBaHBElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsqAzWCJLZEFosESWyILOYIkskQWhwRJZIgs6gyWyRBaEBktkiSzoDJbIElkQGiyRJbKgM1giS2RBaLBElsiCzmCJLJEFocESWSILOoMlskQWhAZLZIks6AyWyBJZEBoskSWyoDNYIktkQWiwRJbIgs5giSyRBaHBElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsqAzWCJLZEFosESWyILOYIkskQWhwRJZIgs6gyWyRBaEBktkiSzoDJbIElkQGiyRJbKgM1giS2RBaLBElsiCzmCJLJEFocESWSILOoMlskQWhAZLZIks6AyWyBJZEBoskSWyoDNYIktkQWiwRJbIgs5giSyRBaHBElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsqAzWCJLZEFosESWyILOYIkskQWhwRJZIgs6gyWyRBaEBktkiSzoDJbIElkQGiyRJbKgM1giS2RBaLBElsiCzmCJLJEFocESWSILOoMlskQWhAZLZIks6AyWyBJZEBoskSWyoDNYIktkQWiwRNbaI2v/3Xs4uS0fLJG19siC09j6wRJZa48sWNNgiSyRBaHBElkiCzqDJbJEFoQGS2SJLOgMlsgSWRAaLJElsjBYmxCRJbIwWCJLZIksDJbIElkwebBElsjCYIkskSWyMFgiS2TB6MESWSILgyWyRJbIwmCJLJEFswdLZIksDJbIElkiC4MlskQWjB4skSWyMFgiS2SJLAyWyBJZMHuwRJbIwmCJLJElsjBYIktkwejBElkiC4MlskSWyMJgiSyRBbMHS2SJLAyWyBJZIguDJbJEFoweLJElsjBYIktkiSwMlsgSWTB7sESWyMJgiSyRJbIwWCJLZMHowRJZIguDJbJElsjCYIkskQWzB0tkiSwMlsgSWSILgyWyRBaMHiyRJbIwWCJLZIksDJbIElkwe7BElsjCYIkskSWyMFgiS2TB6MESWSILgyWyRJbIwmCJLJEFswdLZEHaZhqRBQZLZIksMFgiC5g8WCILDJbIEllgsEQWMHqwRBYYLJElssBgiSxg9mCJLDBYIktkgcESWWCwRNaFOjj0zMBgiSwwWCLLJQsMlsgCDJbIAoMlskQWGCyRBRgskQUGS2SJLDBYIgswWCILDJbIEllgsEQWYLBEFhgskSWywGCJLMBgiSwwWCJLZIHBElmAwRJZYLBElsgCgyWyAIMlssBgiSyRBQZLZIHBQmSBwRJZIgsMlsgCg4XIAoMlskQWGCyRBQYLkQUGS2SJLDBYIgsMFiILDJbIEllgsEQWGCxEFhgskSWywGCJLDBYiCwwWCJLZIHBEllgsBBZYLBElsgCgyWywGAhssBgiSyRBQZLZIHBQmSBwRJZIgsMlsgCgyWyRBYYLJElsjBYiCwwWCJLZIHBElkiC4OFyAKDJbJEFhgskQUGC5EFBktkiSwwWCILDBYiCwyWyBJZYLBEFhgstjqyDg69ZAwW5+SDf4VgsBo++ksIBkteySsMFvIKDJa8kldgsOQVGCzkFRgseSWvwGDJKzBYyCswWPJKXoHBkldgsJBXYLDklbwCgyWvwGAhr8BgySt5BQZLXoHBQl6BwZJX8goMlrwCgyWv5BUYLHklr8BgySswWPJKXoHBkldgsJBXYLDklbwCgyWvwGAhr8BgySt5BQZLXoHBQl6BwZJX8goMlrwCg4W8AoMlr+QVGCx5BQYLeQUGS17JKzBY8goMlrySV2Cw5BVgsOQVGCx5Ja/AYMkrwGDJKzBY8kpegcGSV4DBkldgsOSVvAKDJa8AgyWvwGDJK3kFBktegcFCXoHBklfyCgyWvAKDhbwCgyWv5BUYLHkFBkteySswWPIKMFjyCgyWvJJXYLDkFWCwtjCvDg49MzBY8goMlrxyvQKDJa8AgyWvwGDJK3kFBkteAQZLXoHBklfyCgyWvAIMlrwCgyWv5BUYLHkFGCx5BQZLXsmrM7h1+9M1OLtFXsmr/+bzVV8cBkteySsMlrySV/IKgyWv5BUYLHklrzBY8kpeySsMlrySV2Cw5JW8wmDJK3klrzBY8kpewfTBklfyCoMlr+SVvMJgySt5BSMHS17JKwyWvJJX8gqDJa/kFUwcLHklrzBY8kpeySsMlrySVzBysOSVvMJgySt5Ja8wWPJKXsHEwZJX8gqDJa/klbzCYMkreQUjB0teySsMlrySV/IKgyWv5BVMHCx5Ja8wWPJKXskrDJa8klcwcrDklbzCYMkreSWvMFjySl7BxMGSV/IKgyWv5JW8wmDJK3kFIwdLXskrDJa8klfyCoMlr+QVTBwseSWvMFjySl7JKwyWvJJXMHKw5JW8wmDJK3klrzBY8kpewcTBklfyCiqDJa/kFUQGS17JK6gMlrySVxAZLHklr6AyWPJKXkFksOTVyvPq6MtXOLlFXnFpefXt+4+fcAqLvOKy8urXbx8gqxkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJK3kFlcGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJK3kFlcGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJK3kFlcGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJK3kFlcGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK6gM1vMX8mrNeXX0xyNnRYMlr+QVGCx55XoFocGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJK3kFlcGSV/IKIoMlr+QVVAZLXskriAyWvJJXUBkseSWvIDJY8kpeQWWw5JW8gshgySt5BZXBklfyCiKDJa/kFVQGS17JK4gMlrySV1AZLHklryAyWPJKXkFlsOSVvILIYMkreQWVwZJX8goigyWv5BVUBkteySuIDJa8kldQGSx5Ja8gMljySl5BZbDklbyCyGDJq0vOq6M/XiaccLDklbyCyGDJK9crqAyWvJJXEBkseSWvoDJY8kpeQWSw5JW8gspgySt5BZHBklfyCiqDJa/kFUQGS17JK6gMlrySVxAZLHklr6AyWPJKXkFlsB7Iq2Pt7Mor2JrBQl6BwXK9kldgsOQVGCzkFRgseSWvwGDJKzBYyCswWPJKXoHBkldgsOSVvAKDJa8AgyWvwGDJK3kFBkteAQZLXoHBklfyCgyWvAIMlrwCgyWv5BUYLHkFGCx5BQZLXskrMFjyCjBY8goMlrySV2Cw5BUwfLDkFRgseSWvwGDJK2DkYO3syiswWPJKXoHBcr0C5g2WvAKDJa/kFRgseQWMHCx5BQZLXskrMFjyCpg4WPIKDJa8kldgsOQVMHKw5BUYLHklr8BgyStg4mDJKzBY8kpegcGSV8DIwZJXYLDklbwCgyWvgImDJa/AYMkreQUGS14BIwdLXoHBklfyCgyWvAImDpa8AoMlr+QVGCx5BYwcLHkFBkteySswWPIKmDhY8goMlrySV2Cw5BUwcrDkFRgseSWvwGDJK2DiYMkrMFjySl6BwZJXwMjBkldgsOSVvAKDJa+AiYMlr8BgySt5BQZLXgEjB0tegcGSV/IKDJa8AiYOlrwCKoMlr4DIYMkroDJY8gqIDJa8AiqDJa+AyGDJK6AyWPIKiAyWvAIqgyWvgMhgySugMljyCogMlrwCKoMlr4DIYMkroDJY8gr4l7+GRCuPouf0hgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wNi0zMFQxNjoyMjozNyswMDowMOiBWF8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDYtMzBUMTY6MjI6MzcrMDA6MDCZ3ODjAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    "data-v-23161a6c": "",
    id: "image1",
    width: 1200,
    height: 800,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAMgBAMAAADBzoYxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAD1BMVEWuHCjJZ2////9rhLIhRovc0Yt4AAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+EICgIoH53QvhMAAARUSURBVHja7dJBDQAgEAPBWsACFrCAf02YuD5IZiRsNgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPrCgIBsKjIWxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWBhLAoyFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2NhLDAWxsJYMD3WgYJcKDAWxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2NhLAkwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMhbHAWBgLY8GwB2DTFJhG2Cf4AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTA4LTEwVDAyOjQwOjMxKzAwOjAwadp91wAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0wOC0xMFQwMjo0MDozMSswMDowMBiHxWsAAAAASUVORK5CYII="
  }))), _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    "data-v-23161a6c": "",
    id: "plane-svg",
    xlinkHref: "#plane",
    begin: 0,
    dur: "10s",
    fill: "freeze",
    repeatCount: "indefinite",
    rotate: "auto-reverse",
    keyPoints: "1;0.5;0",
    keyTimes: "0;0.5;1",
    calcMode: "linear"
  }, /*#__PURE__*/React.createElement("mpath", {
    "data-v-23161a6c": "",
    xlinkHref: "#motionPath"
  }))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    "data-v-23161a6c": "",
    id: "sun-svg",
    xlinkHref: "#theSun",
    attributeName: "cy",
    begin: 0,
    from: 300,
    to: 200,
    dur: "10s",
    values: "300; 300; 200; 200; 300",
    keyTimes: "0;0.2;0.5;0.7;1",
    repeatCount: "indefinite",
    fill: "freeze"
  })));
};
export default SvgPlaneDesktop;